import { render, staticRenderFns } from "./CustomerListAddNew.vue?vue&type=template&id=1b84fe55"
import script from "./CustomerListAddNew.vue?vue&type=script&lang=js"
export * from "./CustomerListAddNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports